import { render, staticRenderFns } from "./VaultHeader.vue?vue&type=template&id=7319a0a4&"
import script from "./VaultHeader.vue?vue&type=script&lang=js&"
export * from "./VaultHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports